if (!customElements.get('pickup-store-card')) {
  customElements.define(
    'pickup-store-card',
    class PickupStoreCard extends HTMLElement {
      constructor() {
        super();
        this.hasLoaded = false;

        document.addEventListener('theme-drawer:open', (evt) => {
          const drawer = evt.target.closest('theme-drawer');
          if (drawer && drawer.id === 'pickup-store-drawer' && !this.hasLoaded) {
            this.fetchLocations(this.dataset.variantId);
          }
        });

        document.addEventListener('variant:change', (evt) => {
          if (evt.detail && evt.detail.variant) {
            this.updateVariant(evt.detail.variant.id);
          }
        });

        document.addEventListener('click', (evt) => {
          const target = evt.target instanceof Element ? evt.target : null;
          const button = target?.closest('[data-pickup-checkout]');
          if (!(button instanceof HTMLButtonElement)) return;

          evt.preventDefault();
          this.checkoutWithPickup(button);
        });
      }

      async checkoutWithPickup(button) {
        const variantId = Number(button.dataset.variantId);
        if (!variantId) return;

        let rootUrl = button.dataset.rootUrl || this.dataset.rootUrl || '/';
        if (!rootUrl.endsWith('/')) rootUrl += '/';

        const label = button.textContent;
        button.disabled = true;
        button.textContent = 'Redirecting to checkout…';

        try {
          const response = await fetch(`${rootUrl}cart/add.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] }),
          });

          if (!response.ok) throw new Error('Unable to add this item to cart.');

          window.location.assign(`${rootUrl}checkout`);
        } catch (error) {
          console.error('Pickup checkout failed:', error);
          button.disabled = false;
          button.textContent = label || 'Pick up here';
        }
      }

      updateVariant(variantId) {
        if (!variantId || variantId === this.dataset.variantId) return;
        this.dataset.variantId = variantId;
        this.hasLoaded = false;

        const drawer = document.getElementById('pickup-store-drawer');
        if (drawer && drawer.querySelector('dialog')?.open) {
          this.fetchLocations(variantId);
        }
      }

      getDrawerBody() {
        const drawer = document.getElementById('pickup-store-drawer');
        return drawer ? drawer.querySelector('.pickup-store-drawer__body') : null;
      }

      fetchLocations(variantId) {
        if (!variantId) return;

        let rootUrl = this.dataset.rootUrl || '/';
        if (!rootUrl.endsWith('/')) rootUrl += '/';
        const url = `${rootUrl}variants/${variantId}/?section_id=pickup-availability`;

        const container = this.getDrawerBody();
        if (container) {
          container.innerHTML = `
            <div style="display:flex;align-items:center;justify-content:center;padding:3rem;gap:1rem;font-size:1.3rem;opacity:0.6;">
              <div style="width:2rem;height:2rem;border:0.2rem solid rgba(var(--color-foreground),0.15);border-top-color:currentColor;border-radius:50%;animation:pickupSpin 0.7s linear infinite;"></div>
              <span>Loading store availability...</span>
            </div>
          `;
        }

        fetch(url)
          .then((res) => res.text())
          .then((htmlText) => {
            const parser = new DOMParser();
            const doc = parser.parseFromString(htmlText, 'text/html');
            const list = doc.querySelector('[data-store-availability-drawer-content]');

            if (container) {
              if (list) {
                container.innerHTML = '';
                container.appendChild(
                  document.adoptNode(list)
                );
              } else {
                container.innerHTML = `
                  <div style="padding:3rem 2rem;text-align:center;font-size:1.3rem;opacity:0.5;">
                    <p>Pickup is currently not available for this item.</p>
                  </div>
                `;
              }
            }

            this.hasLoaded = true;
          })
          .catch((err) => {
            console.error('Error fetching store pickup availability:', err);
            if (container) {
              container.innerHTML = `
                <div style="padding:3rem 2rem;text-align:center;font-size:1.3rem;opacity:0.5;">
                  <p>Unable to load store pickup details right now. Please try again.</p>
                </div>
              `;
            }
          });
      }
    }
  );
}
